import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  SxProps,
} from '@mui/material';
import { ReactNode } from 'react';
import { GalleryViewMode } from './types';

export const GalleryCard = ({
  title,
  imgUrl,
  imgAlt,
  viewMode,
  sx,
  children,
  onClick,
}: {
  title: string | ReactNode;
  imgUrl?: string;
  imgAlt?: string;
  viewMode: GalleryViewMode;
  sx?: SxProps;
  children?: React.ReactNode;
  onClick: () => void;
}) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        '&:hover': {
          cursor: 'pointer',
        },
        height: 'max-content',
        minHeight: '100%',
        p: 2,
        ...(viewMode === 'grid' ? {} : { mb: 1 }),
        ...sx,
      }}
    >
      {imgUrl && (
        <CardMedia
          sx={{ p: 3, minHeight: 148, borderRadius: 1 }}
          image={imgUrl}
          aria-label={imgAlt}
          role={imgAlt ? 'img' : 'presentation'}
        />
      )}
      <CardContent className="font-medium" sx={{ p: 0, mt: 1.5 }}>
        {title}
      </CardContent>
      <CardActions className="text-gray-700" sx={{ p: 0 }}>
        {children}
      </CardActions>
    </Card>
  );
};
